export default {
  SwaBizToggle__BUTTON_GROUP_ARIA_NEXT: "Next",
  SwaBizToggle__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
  SwaBizToggle__DIALOG_ARIA_LABEL: "A new window opened",
  SwaBizToggle__LEARN_MORE_LINK: "Learn more",
  SwaBizToggle__TOGGLE_ARIA_LABEL: "Toggle booking with a SWABIZ account",
  SwaBizToggle__TOGGLE_LABEL: "Book with a SWABIZ account",
};
